import { ref } from "@vue/composition-api";
import { Appointment } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";
import {
  AppointmentSlot,
  InputAppointmentSlotBook,
  InputAppointmentSlotSearch,
} from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentSlotProvider";
import {
  AppointmentTypeKind,
  AppointmentTypeList,
  InputAppointmentTypeListSearch,
} from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentTypeProvider";
import providers from "@/lib/api";
import config from "@/config";

export default function useAppointments() {
  const slotsLoading = ref(false);
  const typesLoading = ref(false);
  const isBookingAvailable = ref(false);
  const availableAppointmentKinds = ref<AppointmentTypeKind[]>([]);
  const appointmentTypes = ref<AppointmentTypeList | null>(null);
  const appointmentSlots = ref<AppointmentSlot[]>([]);

  const getAppointmentTypes = async (data: InputAppointmentTypeListSearch) => {
    try {
      typesLoading.value = true;
      const res = await providers.AppointmentTypeProvider.search({ data });
      appointmentTypes.value = res[0] ?? null;
    } finally {
      typesLoading.value = false;
    }
  };

  const checkBookingAvailable = async (userId: string, forSubscribers: boolean) => {
    if (!config.featureAppointments) return;
    await getAppointmentTypes({ userIds: [userId], forSubscribers, checkAdvancedMode: true });

    isBookingAvailable.value = !!appointmentTypes.value && appointmentTypes.value.types.length > 0;

    availableAppointmentKinds.value = Object.values(AppointmentTypeKind).filter(kind =>
      appointmentTypes.value?.types.some(t => t.kind === kind)
    );
  };

  const getAppointmentSlots = async (data: InputAppointmentSlotSearch): Promise<void> => {
    try {
      slotsLoading.value = true;
      appointmentSlots.value = [];
      appointmentSlots.value = await providers.AppointmentSlotProvider.search({ data });
    } finally {
      slotsLoading.value = false;
    }
  };

  const bookAppointmentSlot = (data: InputAppointmentSlotBook): Promise<Appointment> => {
    providers.AppointmentSlotProvider.setReceiveErrors(false);
    return providers.AppointmentSlotProvider.book({ data: data });
  };

  return {
    slotsLoading,
    typesLoading,
    isBookingAvailable,
    appointmentSlots,
    appointmentTypes,
    availableAppointmentKinds,
    checkBookingAvailable,
    getAppointmentTypes,
    bookAppointmentSlot,
    getAppointmentSlots,
  };
}
